/*
 * Copyright (c) 2017 Payoneer Germany GmbH. All rights reserved.
 */

/**
 * Returns the class which is fit for the given dimensions
 * @param {String} challengeWindowSize the dimensions of the LB
 * @param {Object} windowData the size of window
 * @param {Boolean} isMobile
 * @returns {String} class fit for the given dimensions
 */
function getDimensionClass(challengeWindowSize, windowData, isMobile) {
    const possibleChallengeWindowSize = getPossibleChallengeWindowSize(challengeWindowSize, windowData, isMobile);
    switch (possibleChallengeWindowSize) {
        case 'fullPage':
            return 'op-payment-widget-lb-full-page';
        case '250x400':
            return 'op-payment-widget-lb-mobile';
        case '390x400':
            return 'op-payment-widget-lb-small';
        case '600x400':
            return 'op-payment-widget-lb-landscape';
        default:
            return '';
    }
}

/**
 * This function returns the challenge window size which will fit into the current window
 * @param {Object} challengeWindowSize the dimensions object
 * @param {Object} windowData the size of window
 * @param {Boolean} isMobile
 * @return {String} dimension of the lightbox
 */
function getPossibleChallengeWindowSize(challengeWindowSize, windowData, isMobile) {
    if (isMobile) return 'fullPage';
    if (challengeWindowSize && isFitToWindow(challengeWindowSize, windowData)) return challengeWindowSize;
    if (isFitToWindow('500x600', windowData)) return '500x600';
    return 'fullPage';
}

/**
 * Checks whether the lightbox dimensions is fit to the current window size
 * @param {Object} challengeWindowSize the dimensions object
 * @param {Object} windowData contains the height and width of the window
 * @returns {Boolean} returns true if LB is fit else returns false
 */
function isFitToWindow(challengeWindowSize, windowData) {
    var dimensionsValue = challengeWindowSize || '';
    var dimensions = getWidthAndHeight(dimensionsValue, windowData);
    return windowData.width >= dimensions.width && windowData.height >= dimensions.height;
}

/**
 * maps with the dimensions string passed and fetch the width and height of the LB
 * @param {String} dimensions the dimesnions of the lightbox
 * @param {Object} windowData the size of window
 * @returns {Object} the object which comtains the height and width of the LB
 */
function getWidthAndHeight(dimensions, windowData) {
    switch (dimensions) {
        case 'fullPage':
            return { width: windowData.width, height: windowData.height };
        case '250x400':
            return { width: 250, height: 400 };
        case '390x400':
            return { width: 390, height: 400 };
        case '600x400':
            return { width: 600, height: 400 };
        default:
            return { width: 500, height: 600 };
    }
}

module.exports = {
    getDimensionClass,
    getPossibleChallengeWindowSize,
    isFitToWindow,
    getWidthAndHeight,
};
